const SERVICE_WORKER_URL = '/sw.js';

/**
 * Registers the passthrough service worker that makes the app installable.
 *
 * Runs in every environment, including the local dev server, so the install
 * flow can be checked before a release. Storybook never loads the app entry
 * point, so this does not collide with MSW's `mockServiceWorker.js` there.
 */
export default function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register(SERVICE_WORKER_URL).catch((error) => {
      console.error('Service worker registration failed:', error);
    });
  });
}
